import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Bağlarçeşme Koltuk Yıkama", path: "/esenyurt/baglarcesme-koltuk-yikama" },
  { label: "Bağlarçeşme Battaniye Yıkama", path: "/esenyurt/baglarcesme-battaniye-yikama" },
  { label: "Mehterçeşme Koltuk Yıkama", path: "/esenyurt/mehtercesme-koltuk-yikama" },
  { label: "Mehterçeşme Perde Yıkama", path: "/esenyurt/mehtercesme-perde-yikama" },
  { label: "Pınar Mahallesi Koltuk Yıkama", path: "/esenyurt/pinar-koltuk-yikama" },
  { label: "Pınar Mahallesi Yatak Yıkama", path: "/esenyurt/pinar-yatak-yikama" },
  { label: "Talatpaşa Koltuk Yıkama", path: "/esenyurt/talatpasa-koltuk-yikama" },
  { label: "Talatpaşa Yerinde Yıkama", path: "/esenyurt/talatpasa-yerinde-yikama" },
  { label: "İnönü Mahallesi Koltuk Yıkama", path: "/esenyurt/inonu-koltuk-yikama" },
  { label: "İnönü Mahallesi Kuru Temizleme", path: "/esenyurt/inonu-kuru-temizleme" },
  { label: "Esenyurt Merkez Koltuk Yıkama", path: "/esenyurt/merkez-koltuk-yikama" }
];

const EsenyurtServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          ESENYURT HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default EsenyurtServiceArea;
